export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9033.8e6143f9.jpg";